import { render } from "./SalonItems.vue?vue&type=template&id=17bab528"
import script from "./SalonItems.vue?vue&type=script&lang=js"
export * from "./SalonItems.vue?vue&type=script&lang=js"

import "./SalonItems.vue?vue&type=style&index=0&id=17bab528&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__